import { render, staticRenderFns } from "./el-crumbs.vue?vue&type=template&id=aafc5338&"
import script from "./el-crumbs.vue?vue&type=script&lang=js&"
export * from "./el-crumbs.vue?vue&type=script&lang=js&"
import style0 from "./el-crumbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports